import { useEffect, useState } from "react";

const ASSET = "https://customer-assets.emergentagent.com/job_bom-consolidate-1/artifacts";

// 4 rhombus cards, each with its own ordered pool of category-appropriate images.
// All cards rotate in sync every `intervalMs`.
const CARDS = [
  {
    id: "pcb-assembly",
    label: "PCB Assembly",
    images: [
      `${ASSET}/o3nm58ti_pexels-pixabay-163125.jpg`,
      `${ASSET}/fc1ttwjf_pexels-sejio402-6636458.jpg`,
    ],
  },
  {
    id: "electronics-components",
    label: "Electronics Components",
    images: [
      `${ASSET}/fc1ttwjf_pexels-sejio402-6636458.jpg`,
      `${ASSET}/o3nm58ti_pexels-pixabay-163125.jpg`,
    ],
  },
  {
    id: "injection-molding",
    label: "Injection Molding",
    images: [
      `${ASSET}/otkfj0x5_pexels-sejio402-6636472.jpg`,
      `${ASSET}/x8dzji9o_pexels-cookiecutter-17155843.jpg`,
    ],
  },
  {
    id: "rfid-cards",
    label: "RFID Cards",
    images: [
      `${ASSET}/j5tpnr5s_pexels-cottonbro-6501860.jpg`,
      `${ASSET}/fc1ttwjf_pexels-sejio402-6636458.jpg`,
    ],
  },
];

function RhombusCard({ card, slot }) {
  const src = card.images[slot % card.images.length];
  return (
    <div
      data-testid={`rhombus-card-${card.id}`}
      className="flex flex-col items-center justify-center gap-3"
    >
      <div className="relative w-[120px] h-[120px] md:w-[150px] md:h-[150px] flex items-center justify-center">
        {/* Outer glow */}
        <div
          aria-hidden
          className="absolute pointer-events-none w-[90px] h-[90px] md:w-[110px] md:h-[110px]"
          style={{
            transform: "rotate(45deg) scale(1.1)",
            boxShadow: "0 0 40px 4px rgba(57,255,20,0.22)",
            borderRadius: 4,
          }}
        />
        {/* Rhombus frame */}
        <div
          style={{
            transform: "rotate(45deg)",
            border: "2px solid #39FF14",
            boxShadow:
              "0 0 18px rgba(57,255,20,0.45), inset 0 0 20px rgba(57,255,20,0.08)",
          }}
          className="relative w-[90px] h-[90px] md:w-[110px] md:h-[110px] overflow-hidden rounded-sm bg-[#0a0a0a]"
        >
          {card.images.map((img, i) => (
            <img
              key={img}
              src={img}
              alt={card.label}
              loading="lazy"
              style={{ transform: "rotate(-45deg) scale(1.5)" }}
              className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ${
                i === slot % card.images.length ? "opacity-100" : "opacity-0"
              }`}
            />
          ))}
        </div>
      </div>
      <p
        style={{
          fontFamily: "Orbitron, Rajdhani, sans-serif",
          letterSpacing: "0.16em",
        }}
        className="text-[#39FF14] text-[10px] md:text-[11px] uppercase text-center"
      >
        {card.label}
      </p>
    </div>
  );
}

export default function RhombusGrid({ intervalMs = 3000 }) {
  const [slot, setSlot] = useState(0);
  const maxLen = Math.max(...CARDS.map((c) => c.images.length));

  useEffect(() => {
    const t = setInterval(() => {
      setSlot((prev) => (prev + 1) % maxLen);
    }, intervalMs);
    return () => clearInterval(t);
  }, [intervalMs, maxLen]);

  return (
    <div
      data-testid="hero-rhombus-grid"
      className="grid grid-cols-2 gap-x-6 gap-y-4 md:gap-x-10 md:gap-y-6"
    >
      {CARDS.map((card) => (
        <RhombusCard key={card.id} card={card} slot={slot} />
      ))}
    </div>
  );
}
